import { Component } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import errorIcon from '../assets/images/HomeProtectQuestion.png';
import { getConfig } from '../config/configuration';
import { gtmTags } from '../config/configureGtm';
import { errorPageDisplayedAction } from '../engineClient/actions/errorPageDisplayedAction';
import { triggerPageLoadEvent } from '../engineClient/actions/eventActions';
import { addDisplaySizeClassToBodyElement } from '../engineClient/components/pageComponentUtilities';
import { HpHistory, HpUserInterfaceState } from '../engineClient/types';
import { HpGlobalState } from '../types/stateTypes';
import { getErrorPageType, mapToErrorModel } from './errorPageFunctions';
import { HpPageType } from './pageComponentUtilities';

export interface HpStateProps {
  userInterface: HpUserInterfaceState;
}

type HpErrorPageProps = HpStateProps & RouteComponentProps & ErrorPageDispatchProps;

export interface HpErrorPageModel {
  heading: string;
  notFound: boolean;
  paragraph1: string;
  paragraph2: string;
  showContinue: boolean;
  subHeading?: string;
}

const { showErrorPageAfterConsecutiveErrorCount } = getConfig();

class ErrorPage extends Component<HpErrorPageProps> {
  componentDidMount(): void {
    const { pathname: path, hash } = location;
    triggerPageLoadEvent({
      hash,
      path,
      gtmTag: gtmTags.errorPage
    });
    addDisplaySizeClassToBodyElement<HpPageType>({ userInterface: this.props.userInterface, pageType: 'error' });
  }

  componentDidUpdate(): void {
    addDisplaySizeClassToBodyElement<HpPageType>({ userInterface: this.props.userInterface, pageType: 'error' });
  }

  retry(history: HpHistory) {
    this.props.errorPageDisplayed();
    history.push('/');
  }

  render(): JSX.Element {
    const { userInterface, history } = this.props;
    const { fetchError } = userInterface || {};
    const { errorDetails } = fetchError || {};
    const errorPageType = getErrorPageType(fetchError, showErrorPageAfterConsecutiveErrorCount);
    const { heading, subHeading, paragraph1, paragraph2, showContinue, notFound } = mapToErrorModel(
      errorDetails,
      errorPageType
    );

    return (
      <Container className="hp-error">
        <Row>
          <Col>
            <h1>{heading}</h1>
          </Col>
        </Row>
        <Row>
          <Col>
            <p>
              <strong>{subHeading}</strong>
            </p>
          </Col>
        </Row>
        {notFound && (
          <Row>
            <Col>
              <img className="question-mark" src={errorIcon} alt="Homeprotect question mark" />
            </Col>
          </Row>
        )}
        {[paragraph1, paragraph2]
          .filter((p) => !!p)
          .map((p, i) => (
            <Row key={`p${i}`}>
              <Col>
                <p dangerouslySetInnerHTML={{ __html: p }}></p>
              </Col>
            </Row>
          ))}
        {showContinue && (
          <>
            <Row>
              <Col>
                <a onClick={(): void => this.retry(history)} className="btn btn-success">
                  Continue
                </a>
              </Col>
            </Row>
          </>
        )}
      </Container>
    );
  }
}

const mapStateToProps = (state: HpGlobalState): HpStateProps => {
  const { userInterface } = state;
  return { userInterface: { ...userInterface } };
};

interface ErrorPageDispatchProps {
  errorPageDisplayed: () => void;
}

const mapDispatchToProps = (dispatch: (payload: any) => any): ErrorPageDispatchProps => {
  return {
    errorPageDisplayed: (): void => dispatch(errorPageDisplayedAction())
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ErrorPage) as any);
